<template>
  <div class="home">
    <page-header></page-header>
    <div
      class="modal fade parcel_number"
      id="exampleModal1"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      style="display: none"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content text-center rounded-0">
          <div class="modal-header border-0">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeModalErrorWindow()"
            ></button>
          </div>
          <div class="modal-body">
            <h2>PARCEL NUMBER</h2>
            <p class="parcel_number-value">2234234</p>
            <div class="information-parcel text-start">
              <p class="fw-bold text-start">
                We don’t have information for the package you entered due to one
                of the following reasons:
              </p>
              <ul class="parcel_list text-start">
                <li>
                  The package ID you entered is incorrect or missing. Please
                  review it and try again.
                </li>
                <li>
                  The postal code you entered is incorrect or missing. Please
                  review it and try again.
                </li>
                <li>
                  We have not received information for this item from the sender
                  yet.
                </li>
              </ul>
              <p>
                These results reflect the most recent updates in our system. Our
                customer service representatives have access to the same
                information presented here and are unable to provide further
                details at this time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile version of slider -->
    <div class="bannerSlider mobile_slider-section d-lg-none d-block">
      <div class="banner-mobile-center">
        <swiper
          class="banner"
          :autoplay="{ delay: 7500, disableOnInteraction: false }"
          :modules="modules"
          effect="fade"
          :pagination="{ clickable: true }"
        >
          <swiper-slide>
            <img src="../../assets/mobile-slider.png" />
            <div class="bannerCaptionMobile">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>Nous sommes <span> expérimentés</span></h2>
                  <p>Nous livrons des journaux depuis plus de 100 ans.</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../../assets/mobile-slider.png" />
            <div class="bannerCaptionMobile">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>Nous sommes <span> rapides</span></h2>
                  <p>Associé à notre technologie de pointe</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../../assets/mobile-slider.png" />
            <div class="bannerCaptionMobile">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>Nous sommes <span> économiques</span></h2>
                  <p>Nous proposons des prix forfaitaires compétitifs</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../../assets/mobile-slider.png" />
            <div class="bannerCaptionMobile">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>Nous sommes <span> complets</span></h2>
                  <p>
                    Nous sommes fiers d'offrir un système de suivi en
                    libre-service
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../../assets/mobile-slider.png" />
            <div class="bannerCaptionMobile">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>Nous sommes <span> fiables</span></h2>
                  <p>
                    Nous déposons tous les colis en toute sécurité et envoyons
                    une photo immédiatement après la livraison
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../../assets/mobile-slider.png" />
            <div class="bannerCaptionMobile">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>Nous sommes <span> Postmedia Parcel Services</span></h2>
                  <p>
                    Postmedia Parcel Services’ est votre meilleur choix pour la
                    livraison de colis partout au Canada
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <!-- end of mobile slider -->
    <div class="bannerSlider desktop-slider d-lg-block d-none">
      <!--testing putting swiper pagination on left side -->
      <div class="banner-container-left-half">
        <swiper
          class="banner"
          :autoplay="{ delay: 7500, disableOnInteraction: false }"
          :modules="modules"
          effect="fade"
          :pagination="{ clickable: true }"
        >
          <swiper-slide>
            <img src="../../assets/banner1.jpg" />
            <div class="bannerCaption">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>Nous sommes <span> expérimentés</span></h2>
                  <p>Nous livrons des journaux depuis plus de 100 ans.</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../../assets/banner1.jpg" />
            <div class="bannerCaption">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>Nous sommes <span> rapides</span></h2>
                  <p>Associé à notre technologie de pointe</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../../assets/banner1.jpg" />
            <div class="bannerCaption">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>Nous sommes <span> économiques</span></h2>
                  <p>Nous proposons des prix forfaitaires compétitifs</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../../assets/banner1.jpg" />
            <div class="bannerCaption">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>Nous sommes <span> complets</span></h2>
                  <p>
                    Nous sommes fiers d'offrir un système de suivi en
                    libre-service
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../../assets/banner1.jpg" />
            <div class="bannerCaption">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>Nous sommes <span> fiables</span></h2>
                  <p>
                    Nous déposons tous les colis en toute sécurité et envoyons
                    une photo immédiatement après la livraison
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../../assets/banner1.jpg" />
            <div class="bannerCaption">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>Nous sommes <span> Postmedia Parcel Services</span></h2>
                  <p>
                    Postmedia Parcel Services’ est votre meilleur choix pour la
                    livraison de colis partout au Canada
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="TrackingBox">
      <div class="container-sm">

          <div class="row">
            <div class="col-md-12 col-lg-4 textLeft">
              <h1>SUIVEZ VOTRE <span>ENVOI</span></h1>
            </div>
            <div class="col-md-12 col-lg-8 InputRight">
              <div class="input-group">
                <input
                  type="text"
                  name="bniTrackingID"
                  v-model="tracking_id"
                  class="form-control"
                  placeholder="Entrez votre numéro de colis"
                  aria-label="Entrez votre numéro de colis"
                  aria-describedby="button-addon2"
                />
              </div>
              <div class="input-group">
                <input
                  type="text"
                  v-model="postal_code"
                  name="bniPostalCode"
                  class="form-control"
                  placeholder="Entrez votre code postal"
                  aria-label="Entrez votre code postal"
                  aria-describedby="button-addon2"
                />
                <button
                  class="btn track-button"
                  @click="submitToTrackingPage()"
                  name="trackButton"
                  value="trackButton"
                  id="button-addon2"
                >
                  SUBMIT
                </button>
              </div>

              <p>
                Need Support? <a href="#/support" title="Click here">Click here</a>
              </p>
            </div>
            </div>
      </div>
    </div>
    <div id="what-sets-section" class="whatSetSection">
      <div class="container-sm">
        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="leftText">
              <h2 class="pt-5">Ce qui nous distingue</h2>
              <p>
                Couvrant plus de 8 millions de foyers au Canada, choisissez
                ‘Postmedia Parcel Services’ pour livrer vos colis partout au
                pays.
              </p>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <swiper
              class="trackingSlider"
              :slidesPerView="3"
              :centeredSlides="true"
              :loop="true"
              :modules="modules"
              :autoplay="{ delay: 7500, disableOnInteraction: false }"
            >
              <swiper-slide>
                <div class="itemBox">
                  <div class="iconBox">
                    <img src="../../assets/proofIcon.png" alt="" />
                  </div>
                  <div class="itemText">
                    <h4>Preuve de livraison</h4>
                    <p></p>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="itemBox">
                  <div class="iconBox">
                    <img src="../../assets/realtimeIcon.png" alt="" />
                  </div>
                  <div class="itemText">
                    <h4>Suivi mis à jour toutes les 5 minutes</h4>
                    <p></p>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="itemBox">
                  <div class="iconBox">
                    <img src="../../assets/coveringIcon.png" alt="" />
                  </div>
                  <div class="itemText">
                    <h4>Couvrant plus de 8 millions de ménages</h4>
                    <p></p>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="itemBox">
                  <div class="iconBox">
                    <img src="../../assets/api.png" alt="" />
                  </div>
                  <div class="itemText">
                    <h4>
                      Une API améliorée permet une interface directe depuis
                      votre système de point de vente.
                    </h4>
                    <p></p>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="itemBox">
                  <div class="iconBox">
                    <img src="../../assets/support-icon.png" alt="" />
                  </div>
                  <div class="itemText">
                    <h4>Soutien par centre d'appels</h4>
                    <p></p>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="itemBox">
                  <div class="iconBox">
                    <img src="../../assets/tracking-icon.png" alt="" />
                  </div>
                  <div class="itemText">
                    <h4>Portail bilingue de suivi des clients</h4>
                    <p></p>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <!-- <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="ourNetworkSection">
      <div class="container-sm">
        <div class="row">
          <div class="col-md-12 col-lg-7">
            <div class="leftMapBox">
              <h3>
                Notre réseau s'étend d'un<br />
                océan à l'autre
              </h3>
              <img src="../../assets/pmmap.png" alt="Map" />
            </div>
          </div>
          <div class="col-md-12 col-lg-5">
            <div class="mapBulletsText">
              <ul>
                <li>Un réseau fiable et expérimenté</li>
                <li>
                  Livraison le lendemain, le meilleur Service de sa catégorie
                </li>
                <li>Prix forfaitaire compétitif</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="getInTouchSection">
      <div class="container-sm">
        <div class="getInTouch">
          <h5>
            <p>Vous avez besoin de plus d'informations ou de soutien ?</p>
            <a href="#/fr/support" title=""
              >Prenez contact avec nous dès aujourd'hui !</a
            >
          </h5>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import PageFooter from "../fr/PageFooter.vue";
import PageHeader from "../fr/PageHeader.vue";
import { Pagination, EffectFade, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import axios from "axios";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { parcel_api } from '@/js_utils/urls.js'

export default {
  name: "HomePage",
  components: {
    PageHeader,
    Swiper,
    SwiperSlide,
    PageFooter,
  },
  beforeMount() {
    scroll(0, 0);
  },
  mounted() {
     let uri = window.location.search.substring(1);
     let params = new URLSearchParams(uri);

     if (params.size != 0) {
       this.tracking_id = params.get("bniTrackingID");
       this.postal_code = params.get("bniPostalCode");
       this.submitToTrackingPage();

    }
  },

  methods: {
    submitToTrackingPage() {
      this.postal_code = this.postal_code.trim().toUpperCase();
      this.tracking_id = this.tracking_id.trim().toUpperCase();

      let submit_button = document.querySelector(".track-button");
      submit_button.disabled = true;

      if (this.tracking_id.trim() == "" || this.postal_code.trim() == "") {
        document.querySelector(".parcel_number").classList.add("show");
        document.querySelector(".parcel_number").style.display = "block";
        document.querySelector(".parcel_number").ariaModal = true;
        document.querySelector(".parcel_number-value").innerHTML =
          this.tracking_id;
        submit_button.blur();
        submit_button.disabled = false;
      } else {
        if (this.postal_code.length == 6) {
          let first_half = this.postal_code.slice(
            0,
            this.postal_code.length / 2
          );
          let second_half = this.postal_code.slice(
            this.postal_code.length / 2,
            this.postal_code.length
          );
          this.postal_code = first_half + " " + second_half;
        }

        let tracking_postal = this.tracking_id + "+" + this.postal_code;
        axios
          .get(parcel_api.concat('/query/'+tracking_postal))

          .then((res) => {
            if (res["data"]["statuses"] == undefined) {
              document.querySelector(".parcel_number").classList.add("show");
              document.querySelector(".parcel_number").style.display = "block";
              document.querySelector(".parcel_number").ariaModal = true;
              document.querySelector(".parcel_number-value").innerHTML =
                this.tracking_id;
            } else {
              submit_button.blur();
              submit_button.disabled = false;
              sessionStorage.setItem("tracking_id", this.tracking_id);
              sessionStorage.setItem("postal_code", this.postal_code);
              sessionStorage.setItem("data", JSON.stringify(res));
              this.$router.push("/fr/track-your-shipment");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      submit_button.blur();
      submit_button.disabled = false;
    },
    closeModalErrorWindow() {
      document.querySelector(".parcel_number").classList.remove("show");
      document.querySelector(".parcel_number").style.display = "none";
      document.querySelector(".parcel_number").ariaModal = false;
      document.querySelector(".parcel_number-value").innerHTML = "";
    },
  },
  data: function () {
    return {
      tracking_id: "",
      postal_code: "",
    };
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSliderChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSliderChange,
      modules: [Pagination, EffectFade, Autoplay],
    };
  },
};
</script>